import type React from 'react'
import { useState } from 'react'

import { BlockSpace, Container, LoadingModal, Page } from 'components'
import { Channels, Sectors, TypesValidations } from 'constants/enums'
import Materials from 'container/SalesOrder/components/Materials'
import { FormProvider, useForm } from 'react-hook-form'

import TopSection from './components/TopSection'

/**
 * @deprecated This service/type is deprecated and should not be used in new features
 * Use the new services/types from `services/shared/customers`
 */
export interface Cliente {
  rowscount: number
  cd_empr: string
  cd_orgn_vend: string
  cd_canl_dstb: string
  cd_seto_atvd: string
  cd_escr_vend: string
  cd_equi_vend: string
  cd_regi_vend: string
  ds_regi_vend: string
  cd_clie: string
  nm_clie: string
  nr_cnpj_cpf: string
  nr_insc_estl: string
  ds_endr: string
  ds_endr_numc: string
  ds_endr_cmpt: string
  ds_bair: string
  nm_cidd: string
  cd_uf: string
  EnderecoFormatado: string
}

const CreateOrder: React.FC = () => {
  const [loading, setLoading] = useState(false)

  const initialFields = {
    address: '',
    cd_canl_dstb: Channels.MI,
    cd_catg_item: '',
    cd_cent_cust: '',
    cd_clie: {} as Cliente,
    cd_clie_entr: '',
    cd_cond_pgto: '',
    cd_elem_pep: '',
    cd_moti_prom: '',
    cd_regi_vend: undefined,
    cd_seto_atvd: Sectors.AC,
    cd_tipo_orde: '',
    ds_cond_pgto: '',
    ds_grup_clie: '--',
    ds_text_nota_fisc: '',
    dt_ano_mes_cota: '',
    dt_dsjd_pedi: '',
    fl_dsct_matr: TypesValidations.NO,
    fl_mto_prep: TypesValidations.NO,
    fl_prmt_desd: TypesValidations.NO,
    nr_cnpj_cpf: '---',
    nr_dias_adic: '0',
    nr_insc_estl: '--',
    nr_pedi_clie: '',
    pc_dsct: 0,
  }

  const methods = useForm({
    defaultValues: initialFields,
    mode: 'all',
    reValidateMode: 'onBlur',
  })

  const runnable = () => {
    return
  }
  const renderMaterials = () => (
    <Materials
      handleFieldModified={runnable}
      handleRequestMaterials={runnable}
      hasCustommer
      hasUnsavedOVConfig
      requestMaterials={{ handleRequestMaterials: runnable, loading: false }}
      setModalMaterialsLimit={runnable}
      user=""
    />
  )
  return (
    <FormProvider {...methods}>
      <Page
        fullwidth
        renderHeaderComponent={
          <TopSection isButtonRescueData setLoading={setLoading} showDeleteModal={false} />
        }
      >
        {loading && <LoadingModal />}
        <Container fullwidth={true}>
          <BlockSpace content={[renderMaterials()]} id="materialList" />
        </Container>
      </Page>
    </FormProvider>
  )
}

export default CreateOrder
